import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
    providedIn: 'root'
})
export class RequerimientosService {

    constructor(private api: ApiService) {}

    /* -------------------------------------------------------------------------- */
    /*                         OBTENER ORDENES SERVER SIDE                        */
    /* -------------------------------------------------------------------------- */
    obtenerRequerimiento(_tipo,item, valor, estado, estadoTomo) {
      return this.api.post<{ rows: any[] }>('/transactions/requirements/list', {
        item,
        valor,
        estado,
        estadoTomo
      });
    }

    /* -------------------------------------------------------------------------- */
    /*                   ACTUALIZAR ESTADO ENTREGA REQUERIMIENTO                  */
    /* -------------------------------------------------------------------------- */
    actualizarEstado(_tipo,_codigoDoctor,tipoEntrega, idRequerimiento){
      return this.api.post('/transactions/requirements/delivery/update', {
        tipoEntrega,
        idRequerimiento: Number(idRequerimiento)
      }).pipe(map(() => 'ok'));
    }

   /* -------------------------------------------------------------------------- */
   /*                         ENVIAR NOTIFICACION ASESOR                         */
   /* -------------------------------------------------------------------------- */
   enviarNotificacion(observacion,descripcion, asesor, requerimiento){
      return this.api.post('/transactions/requirements/response/notify', {
        advisorName: asesor,
        description: observacion || '',
        observation: descripcion,
        requirementId: Number(requerimiento)
      }).pipe(map(() => 'ok'));
    }



    
   /* -------------------------------------------------------------------------- */
   /*                         ENVIAR NOTIFICACION ASESOR                         */
   /* -------------------------------------------------------------------------- */
   enviarNotificacionPaciente(orden, observacion){
      return this.api.post('/transactions/requirements/patient/notify', {
        observation: observacion,
        orderNumber: orden
      }).pipe(map(() => 'ok'));
    }
    

    marcarAntendido(fecha,usuario, idRequerimiento,_token){
      return this.api.post('/transactions/requirements/mark-attended', {
        fecha,
        usuario,
        idRequerimiento: Number(idRequerimiento)
      }).pipe(map(() => 'ok'));
    }
    
}
